import { createSelector } from '@reduxjs/toolkit';
import { FDealType } from '../../../../packages/JsonQuery';
import { selectDealType } from 'shared/selectors/jsonQuery';

export const selectRoomsInDealLabel = createSelector(selectDealType, dealType =>
  FDealType.Rent & dealType ? 'Комнат в аренду' : 'Комнат на продажу',
);
